import { timeoutFormat } from './timeout.filter';
/**
 * 
 * @param {*} Vue 
 */
export const filterService = (Vue) => {
    timeoutFormat(Vue);
}


// WEBPACK FOOTER //
// ./src/_filters/index.js